module.exports = __webpack_public_path__ + "img/caseBuilder-hrRecruiter.877eac04.webp";